/**
 * ENTITY PHONES STORE
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getEntityPhones,
    getEntityPhone,
    printEntityPhone,
    createEntityPhones,
    updateEntityPhones,
    deleteEntityPhones,
} from "Core/entities/config/api.entity_phones";

const state = {
    page: {},
    form: {},
    entity_phones: [],
    entity_phone_options: [],
    selectedEntityPhone: {
        entity_phones_id: null,
        company_id: "",
        entity_phone_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        entity_phone_details: [],
    },
    entity_phones_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
    },
    rules_entity_phones: {
        entity_phones_id: {
            name: "entity_phones_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        object_ref: {
            name: "object_ref",
            rules: "trim|max_length[10]|required",
            max_len: "10",
            min_len: "",
            default_value: "",
        },
        object_id: {
            name: "object_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        phone_type: {
            name: "phone_type",
            rules: "trim|max_length[45]|required",
            max_len: "45",
            min_len: "",
            default_value: "",
        },
        country_id: {
            name: "country_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "140",
        },
        phone_number: {
            name: "phone_number",
            rules: "trim|max_length[16]",
            max_len: "16",
            min_len: "",
            default_value: "",
        },
        phone_number_formatted: {
            name: "phone_number_formatted|required",
            rules: "trim|max_length[24]",
            max_len: "24",
            min_len: "",
            default_value: "",
        },
        country_iso_2: {
            name: "country_iso_2",
            rules: "trim|max_length[2]",
            max_len: "2",
            min_len: "",
            default_value: "",
        },
        country_iso_3: {
            name: "country_iso_3",
            rules: "trim|max_length[3]",
            max_len: "3",
            min_len: "",
            default_value: "",
        },
        phone_extension: {
            name: "phone_extension",
            rules: "trim|max_length[20]",
            max_len: "20",
            min_len: "",
            default_value: "",
        },
        prime: {
            name: "prime",
            rules: "trim|max_length[1]|integer",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        new_prime_entity_phones_id: {
            name: "new_prime_entity_phones_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
    },
};

// getters
const getters = {
    entity_phones: (state) => {
        return state.entity_phones;
    },
};

// actions
const actions = {
    async fetchEntityPhones({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getEntityPhones({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("setPageEntityPhones", response.data.page);
                }

                if (body.options) {
                    commit("setFePartOptions", response.data.fe_parts);
                    commit("setEntityPhonesOptions", response.data.entity_phones);
                } else {
                    commit("setEntityPhones", response.data.entity_phones);
                }

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchEntityPhone({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getEntityPhone(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("setSelectedEntityPhone", response.data.entity_phone);
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printEntityPhone({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printEntityPhone(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveEntityPhone({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["entity_phones_id"] === "undefined" || body["entity_phones_id"] == null || body["entity_phones_id"] == "") {
                delete body["entity_phones_id"];
                response = await createEntityPhones({ body: body, headers: config.headers });
            } else {
                let entity_phones_id = body["entity_phones_id"];
                delete body["entity_phones_id"];
                response = await updateEntityPhones({ body: body, headers: config.headers }, entity_phones_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteEntityPhone({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteEntityPhones(payload.id, payload.new_prime_entity_phones_id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    setPageEntityPhones(state, page) {
        state.page = page;
    },
    setEntityPhones(state, entity_phones) {
        state.entity_phones = entity_phones;
    },
    setEntityPhonesOptions(state, entity_phones) {
        state.entity_phone_options = entity_phones;
    },
    setSelectedEntityPhone(state, entity_phone) {
        state.selectedEntityPhone = entity_phone;
    },
    resetSelectedEntityPhone(state) {
        for (const key in state.selectedEntityPhone) {
            if (key in state.rules_entity_phones) {
                state.selectedEntityPhone[key] = state.rules_entity_phones[key].default_value == "null" ? null : state.rules_entity_phones[key].default_value;
            }
        }
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
